import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import 'firebase/compat/auth'

export default class FirebaseInstance {
  static get() {
    return firebase.database().ref()
  }

  static auth() {
    return firebase.auth()
  }

  static serverTimestamp() {
    return firebase.database.ServerValue.TIMESTAMP
  }
}
